// Central tour versioning. Bump version when UI changes meaningfully.
// Users who saw version N will re-see the tour if current version > N.
// Property detail steps: src/lib/propertyDetailTourSteps.ts

/** Kill switch — tours slowed the app; re-enable when redesigned. */
export const TOURS_ENABLED = false;

export const TOUR_VERSIONS: Record<string, number> = {
  "owner-property-detail": 4,
  "owner-dashboard": 1,
  "cleaner-dashboard": 1,
};

const STORAGE_KEY = "stravo_tours_seen";

type SeenMap = Record<string, number>;

function load(): SeenMap {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "{}") as SeenMap;
  } catch {
    return {};
  }
}

function save(map: SeenMap): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
}

export function hasTourBeenSeen(tourId: string): boolean {
  if (!TOURS_ENABLED) return true;
  const seen = load();
  const seenVersion = seen[tourId] ?? 0;
  const currentVersion = TOUR_VERSIONS[tourId] ?? 1;
  return seenVersion >= currentVersion;
}

export function markTourSeen(tourId: string): void {
  if (!TOURS_ENABLED) return;
  const seen = load();
  seen[tourId] = TOUR_VERSIONS[tourId] ?? 1;
  save(seen);
}

export function resetAllTours(): void {
  localStorage.removeItem(STORAGE_KEY);
}

const PENDING_KEY = "stravo_tour_pending";

export function setPendingTour(tourId: string): void {
  if (!TOURS_ENABLED) return;
  localStorage.setItem(PENDING_KEY, tourId);
}

export function peekPendingTour(): string | null {
  if (!TOURS_ENABLED) return null;
  return localStorage.getItem(PENDING_KEY);
}

export function consumePendingTour(): string | null {
  if (!TOURS_ENABLED) return null;
  const t = localStorage.getItem(PENDING_KEY);
  localStorage.removeItem(PENDING_KEY);
  return t;
}
